import React from 'react';
import '../Styles/Services.css'
import WebDesign from '../Assets/Images/Web-Design.jpg'
import WebDevelopment from '../Assets/Images/WebDevelopment.png'
import UiUx from '../Assets/Images/UX_UI.jpg'
import Graphic from '../Assets/Images/Grapic.jpg'
import ReactNative from '../Assets/Images/React-Native.jpg'
import Digital from '../Assets/Images/Digital.jpg'

const Services = () => {
    return (
        <div className='service lg:py-10'>
            <div>
                <h1 className='text-center text-3xl font-bold p-5 lg:px-96'>REASON FOR CHOOSING US AS YOUR
                    SERVICE PROVIDER</h1>
            </div>
            <div className=''>
                <div class="single-collection">
                    <article class="itemblog">
                        <img src={WebDesign} alt="" />
                        <h4>Web Design</h4>

                        <p>This lightweight tripod allows you to make photos and videos without having to hold the
                            camera steady yourself.</p>
                    </article>
                    <article class="itemblog">
                        <img src={WebDevelopment} alt="" />
                        <h4>Web Development</h4>

                        <p>A microphone, colloquially called a mic or mike (/maɪk/), is a device – a transducer – that
                            converts sound into an electrical signal</p>
                    </article>
                    <article class="itemblog">
                        <img src={UiUx} alt="" />
                        <h4>Ux-Ui Design</h4>

                        <p>With the Noise Air Buds Mini Truly Wireless Bluetooth earbuds, you can take calls, groove to
                            your favourite music, or exercise to adrenaline-pumping hits.</p>
                    </article>
                    <article class="itemblog">
                        <img src={Graphic} alt="" />
                        <h4>Graphic Design</h4>

                        <p>A drone is an unmanned aircraft. Drones are more formally known as unmanned aerial vehicles
                            (UAVs) or unmanned aircraft systems.</p>
                    </article>
                    <article class="itemblog">
                        <img src={ReactNative} alt="" />
                        <h4>App Development</h4>

                        <p>When setting up your vehicle lighting, it is well worth considering how and where you will be
                            using your new lights in order to choose the right setup.</p>
                    </article>
                    <article class="itemblog">
                        <img src={Digital} alt="" />
                        <h4>Digital Marketing</h4>

                        <p>When setting up your vehicle lighting, it is well worth considering how and where you will be
                            using your new lights in order to choose the right setup.</p>
                    </article>
                </div>
            </div>

        </div>
    );
};

export default Services;